import styled from "styled-components"

const Input = styled.input`
    width: 100%;
    height: 40px;
    box-shadow: 0 0 5px 0 #00000011;
    border: 1px solid #ecf1f6;
    border-radius: 5px;
    padding: 0px 10px;

    ::placeholder {
        color: #94A3B8;
    }
`

export default Input

